<template>
  <div
    class="pcb-item"
    v-if="show"
    :class="{
      'pcb-item-checked': checked,
      'is-error': isError,
      disabled: disabled,
      hasBorder: noBorder,
      'pcb-item-bg': bg,
    }"
    :style="{ minWidth: minWidth + 'px',height:validataNull(props.img)?'28px':'45px'}"
    @click="emit('click', $event)"
  >
    <div
      :data-dicValue="value"

      class="pcb-item-content"
      :class="{ disabledColor: disabled,'pcb-item-hasimg':!validataNull(props.img) }"

    >
      <img v-if="img" :src="img" class="pcb-item-img" />
      <div
        class="pcb-item-color"
        :style="colorStyle"
        v-if="
          colorValue &&
          colorValue !== 'none' &&
          colorValue !== 'None' &&
          isColor
        "
      ></div>
      <div
        class="pcb-item-color-x"
        v-if="(colorValue === 'none' || colorValue === 'None') && isColor"
      >
        <span class="pcb-item-color-x-icon">☒</span>
      </div>
      <slot></slot>
    </div>
    <!-- 右下角选中指示器 -->

  </div>
</template>

<script setup>
import { computed } from "vue";
import { validataNull } from "../utils";
defineOptions({
  name: "pcb-item",
});

const emit = defineEmits(["click"]);
const colorConfig = {
  green: "#007606",
  white: "#fff",
  black: "#000",
  red: "#C81609",
  yellow: "#FFDE00",
  blue: "#0943C8",
  matteblack: "#333333",
  mattegreen: "#46C017",
  coldwhite: "",
  none: "none",
};
const colorValue = computed(() => {
  const val = props.value;
  if (
    val !== "" &&
    typeof val === "string" &&
    val.toLowerCase() in colorConfig
  ) {
    return colorConfig[val.toLowerCase()];
  }
  return props.color;
});
const props = defineProps({
  checked: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: "",
  },
  show: {
    type: Boolean,
    default: true,
  },
  bg: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: "",
  },
  isError: {
    type: Boolean,
    default: false,
  },
  minWidth: {
    type: Number,
    default: 50,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  noBorder: {
    type: Boolean,
    default: false,
  },
  isColor: {
    type: Boolean,
    default: true,
  },
  img:{
    type:String,
    default:""
  }
});
const colorStyle = computed(() => {
  let color = colorValue.value;
  return {
    background: color,
    border:
      color === "#fff" || color == "#ffffff" || color === "white"
        ? "1px solid #ccc"
        : "1px solid " + color,
  };
});
</script>

<style>
/* .is-error {
  border: 1px solid rgb(var(--danger-6)) !important;
} */
.disabledColor {
  color: #bbb !important;
}
.disabled {
  cursor: not-allowed !important;
  background: #ffffff !important;
  color: #bbb !important;
  border: 1px solid #d9d9d9 !important;
}
.disabled:hover {
  /* border:none !important; */
  border: 1px solid #d9d9d9 !important;
}
.pcb-item-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pcb-item {
  font-family: "HarmonyOS_Sans", Roboto, Tahoma, Arial, "Microsoft YaHei UI" !important;
  position: relative;
  color: #666;
  border: 1px solid #d9d9d9;
  min-width: 50px;
  font-weight: 400;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  margin-bottom: 0;
  background: #fff;
  border-radius: 2px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  padding: 0px 12px;
  overflow: hidden;
  font-size: 12px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.pcb-item-checked {
  color: #333;
  font-weight: 400;
  background: #eff5ff;
  border: 1px solid  #0060FF;
  border-right: 4px solid var(--primary-color, #0060FF);
  border-radius: 2px;
}

.pcb-item:hover {
  border-color: var(--main-color,#0060FF);
}
.hasBorder {
  border: none;
  margin: 1px 0;
}
.hasBorder:hover {
  background-color: #ebf7f8;
  border: "none";
}

.pcb-item-indicator {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-left: 16px solid transparent;
  border-bottom: 16px solid var(--main-color);
  /* display: flex;
  align-items: flex-end;
  justify-content: flex-end; */
}

.pcb-item-check-icon {
  font-size: 13px;
  font-weight: 200;
  position: absolute;
  width: 12px;
  height: 12px;
  color: #fff;
  bottom: -9px;
  right: -2px;
  transform: rotate(12deg);
}
.pcb-item {
  transition: all 0.2s ease-in-out;
}

.pcb-item-indicator {
  animation: fadeInCorner 0.2s ease-in-out;
}

@keyframes fadeInCorner {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.pcb-item-color {
  width: 0.8em;
  height: 0.8em;
  margin-right: 0.5em;
  border-radius: 2px;
  line-height: 1em;
}
.pcb-item-color-x {
  display: inline-block;
  text-align: center;
  width: 1em;
  height: 1em;
  border-radius: 2px;
  margin-right: 0.5em;
  position: relative;
}
.pcb-item-color-x-icon {
  font-size: 1.5em;
  position: absolute;
  color: #ccc;
  width: 1em;
  height: 1em;
  top: -0.2em;
  left: -0.15em;
  line-height: 1em;
}
.pcb-item-bg {
  background:linear-gradient(90deg, rgba(0, 96, 255, 0.05) -4.41%, rgba(255, 255, 255, 0.12) 90.22%, #FFFFFF 100%) !important;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid;
  border-image:linear-gradient(
        90deg,
        rgba(41, 65, 205, 0.5),
        rgba(0, 139, 255, 0.22),
        rgba(187, 224, 255, 0.45)
      )
      1 1 !important
}
.pcb-item-bg:hover {
  border: 1px solid #0060FF;
}
.pcb-item-hasimg{
  flex-direction: column;
  line-height: 22px;
  padding-top: 5px;
}
.pcb-item-hasimg img{
width: 33px;
height: 20px;
}
</style>
